import { sharedColors } from "../../../Themes/allThemes";
import styled from "styled-components";
export const Link = styled.a `
  align-items: baseline;
  align-content: center;
  color: ${sharedColors.black};
  cursor: ${({ $complete }) => ($complete ? "pointer" : "default")};
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  min-width: 0;
  min-height: 44px;
  text-decoration: ${({ $complete }) => $complete && "underline"};
`;
export const DisabledTitle = styled.div `
  align-items: baseline;
  align-content: center;
  color: ${sharedColors.black};
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  min-width: 0;
  min-height: 44px;
`;
//# sourceMappingURL=styled.js.map